import { render, staticRenderFns } from "./pdfNoticeCard.vue?vue&type=template&id=42d39d44&scoped=true&"
import script from "./pdfNoticeCard.vue?vue&type=script&lang=js&"
export * from "./pdfNoticeCard.vue?vue&type=script&lang=js&"
import style0 from "./pdfNoticeCard.vue?vue&type=style&index=0&id=42d39d44&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42d39d44",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VIcon,VRow})
